import { PageId } from 'constants/pages'

export const enum PageIdWoofzOffer270 {
  SUBSCRIPTIONS_OFFER2_70 = PageId.SUBSCRIPTIONS_OFFER2_70,
  CHAT_UPSELL_OFFER2_70 = PageId.CHAT_UPSELL_OFFER2_70,
  UPSELL_OFFER2_70 = PageId.UPSELL_OFFER2_70,
  DOWNLOAD_OFFER2_70 = PageId.DOWNLOAD_OFFER2_70,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
}
